import * as React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import styles from './RubricsView.scss';

interface EditRubricsViewProps {
    rubricsContentItemId: number;
    rubricsContentRevisionId?: number;
    mode?: string;
    enableAiAssistedMarking?: boolean;
    onIframeLoad: () => void;
}

const EditRubricsView: React.FC<EditRubricsViewProps> = ({
    rubricsContentItemId,
    rubricsContentRevisionId,
    mode = 'editMode',
    enableAiAssistedMarking,
    onIframeLoad,
}) => {
    const itemBankId = useSelector((state: RootState) => state?.context?.itemBankId);

    const frameUrl = React.useMemo(() => {
        const params = new URLSearchParams({
            contentItemId: String(rubricsContentItemId),
        });

        if (rubricsContentRevisionId) {
            params.append('contentRevisionId', String(rubricsContentRevisionId));
        }

        if (mode) {
            params.append('mode', mode);
        }

        if (itemBankId && itemBankId !== -1) {
            params.append('itemBankId', String(itemBankId));
        }

        if (enableAiAssistedMarking) {
            params.append('enableAiAssistedMarking', 'true');
        }

        return `/rubrics?${params.toString()}`;
    }, [rubricsContentItemId, rubricsContentRevisionId, mode, itemBankId, enableAiAssistedMarking]);

    return (
        <div className={styles.iframeContainer}>
            <iframe
                name="embeddedApp"
                src={frameUrl}
                onLoad={onIframeLoad}
                className={styles.rubricsIframe}
                title="Edit Rubrics"
            />
        </div>
    );
};

export default EditRubricsView;
